<template>
  <div class="flex justify-center items-center">
    <span class="loader" :style="sizeStyle" />
  </div>
</template>

<script>
export default {
  props: {
    size: {
      type: String,
      default: '30px',
    },
  },
  computed: {
    sizeStyle() {
      return { width: this.size, height: this.size };
    },
  },
};
</script>

<style scoped>
.loader {
  border: 5px solid currentColor;
  border-bottom-color: transparent;
  border-radius: 50%;
  display: inline-block;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;
}

@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
